export default __webpack_public_path__ + "static/testimonials-f264e233be92247da9325ed587708030.png";